import { createReducer } from '@reduxjs/toolkit';
import toggleBasketModal from '../actions/basketToggle';

const initialState = {
  visible: false,
};
export default createReducer(initialState, (builder) => {
  builder.addCase(toggleBasketModal, (state, action) => action.payload);
});
